<script setup lang="ts">
import { Checkbox } from './checkbox'

defineOptions({
  name: 'FaCheckbox',
})

defineProps<{
  disabled?: boolean
}>()

const value = defineModel<boolean>()
</script>

<template>
  <div class="flex-center-start cursor-pointer gap-2" @click="!disabled && (value = !value)">
    <Checkbox v-model="value" :disabled />
    <span class="select-none text-sm">
      <slot />
    </span>
  </div>
</template>
